import './CopyC.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';

export interface CopyCContentType {
  asset?: b2x.contentTypes.AssetContentSectionV2;
  content?: string;
  cta?: b2x.contentTypes.CtaContentSection;
  mainComponent?: boolean;
  options?: {
    desktop?: {
      background?: string;
      color?: string;
    };
    mobile?: {
      background?: string;
      color?: string;
    };
  };
  title?: string;
}

interface CopyCProps extends CopyCContentType {}

export const CopyC = ({ asset, content, cta, mainComponent, options, title }: CopyCProps) => {
  const currentBreakpoint = b2x.useBreakpoint();

  return (
    <b2x.Div className="copy-c">
      <Container fluid="always">
        <b2x.Div style={{ position: 'relative' }}>
          <b2x.AssetV2 {...asset} fluid />
          <b2x.Div className="copy-container">
            <b2x.Row>
              <b2x.Col size={12}>
                <b2x.Div
                  background={
                    b2x.untilBreakpoint('md', currentBreakpoint)
                      ? options?.mobile?.background
                      : options?.desktop?.background
                  }
                  padding={5}
                  style={{
                    color: b2x.untilBreakpoint('md', currentBreakpoint)
                      ? options?.mobile?.color
                      : options?.desktop?.color,
                  }}
                >
                  <b2x.ConditionalWrapper
                    condition={title !== undefined}
                    wrapper={
                      mainComponent ? (
                        <b2x.H1 className="title" fontWeight={700} marginBottom={3} />
                      ) : (
                        <b2x.P className="title" fontWeight={700} marginBottom={3} />
                      )
                    }
                  >
                    {b2x.formatHtml(title)}
                  </b2x.ConditionalWrapper>
                  {content && (
                    <b2x.Div className="content" marginBottom={4}>
                      {b2x.formatHtml(content)}
                    </b2x.Div>
                  )}
                  {cta?.label && <b2x.CtaFromContent {...cta} />}
                </b2x.Div>
              </b2x.Col>
            </b2x.Row>
          </b2x.Div>
        </b2x.Div>
      </Container>
    </b2x.Div>
  );
};
